import AccrediteesGrantedDayCell from 'app/backbone/views/event/accreditation/accreditees/profiles/tables/cells/GrantedDayCell.view';

export default class GrantedDayCell extends AccrediteesGrantedDayCell {

    isDisabled() {
        return ! this.model.isAvailableOn(this.day);
    }

}
